import { emptyValidator, formValidator } from "../../validators";

const stakeholderGroupValidationStatus = {
  grpGroup: {
    validators: [emptyValidator()],
    name: "Stakeholder Group Name",
  },
};
export const stakeholderGroupValidation = (stakeholderGroup) => {
  return formValidator(stakeholderGroup, stakeholderGroupValidationStatus);
};
